'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _ = require('../');
var _constants = require('../../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

supportedLanguages = _constants.language.supportedLanguages;
var pagesWithFullLogo = ['homes', 'commercial', 'projects'];var

AppHeader = function (_Component) {_inherits(AppHeader, _Component);function AppHeader() {var _temp, _this, _ret;_classCallCheck(this, AppHeader);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    isLocalizedHomePage = function (route) {return supportedLanguages.map(function (lang) {return '/' + lang + '/';}).some(function (locRoute) {return locRoute === route;});}, _this.

    isHomePage = function () {return !_this.props.location || _this.props.route === '/' || _this.isLocalizedHomePage(_this.props.route);}, _this.
    isContactByRealtorPage = function () {return _this.props.route.includes('contact_us_realtor');}, _this.
    isFullMobileLogo = function () {return _this.isHomePage() ||
      pagesWithFullLogo.some(function (routePart) {return _this.props.route.includes(routePart);});}, _temp), _possibleConstructorReturn(_this, _ret);}AppHeader.prototype.

  render = function render() {
    if (typeof document !== 'undefined') {
      document.body.style.overflow = '';
    }var _props =




    this.props,isMobile = _props.isMobile,route = _props.route,locale = _props.locale,location = _props.location,logOut = _props.logOut,translate = _props.translate,isNative = _props.isNative,isRtl = _props.isRtl,routeData = _props.routeData,openAuthenticationModal = _props.openAuthenticationModal,openMessageModal = _props.openMessageModal,publishClicked = _props.publishClicked,pushRoute = _props.pushRoute,userHasProperties = _props.userHasProperties,userHasCompany = _props.userHasCompany,switchAccountView = _props.switchAccountView,setPaginationStepForAgentManage = _props.setPaginationStepForAgentManage;

    if (isMobile && (location === 'home_details' || location === 'project_details')) {
      return null;
    }var _props$userAuthentica =

    this.props.userAuthentication,userData = _props$userAuthentica.data,userIsAuthorized = _props$userAuthentica.userIsAuthorized;
    var userPropertiesCounters = userData ? userData.properties : {};
    var isAgent = userData && userData.is_agent;var
    isModalContactsOpen = this.props.propertyDetails.isModalContactsOpen;
    var isForeignPublish = (0, _get2.default)(userData, 'publish_permissions.foreign');
    var isForeignDraft = routeData.location === 'foreign_publish';

    var sharedProps = {
      route: route,
      locale: locale,
      location: location,
      isAgent: isAgent,
      translate: translate,
      userHasProperties: userHasProperties,
      userHasCompany: userHasCompany,
      userIsAuthorized: userIsAuthorized,
      openMessageModal: openMessageModal,
      switchAccountView: switchAccountView,
      userPropertiesCounters: userPropertiesCounters,
      openAuthenticationModal: openAuthenticationModal,
      logOut: logOut,
      publishClicked: publishClicked,
      pushRoute: pushRoute,
      isRtl: isRtl,
      routeData: routeData,
      isForeignDraft: isForeignDraft,
      isForeignPublish: isForeignPublish,
      isHomePage: this.isHomePage(),
      isHomePageStyles: !isMobile && this.isContactByRealtorPage(),
      isHomesResultPage: (0, _constants.getSectionsNames)().includes(routeData.location),
      savePublishDraft: this.props.savePublishDraft,
      publishDraftSaved: this.props.publishDraftSaved,
      canSavePublishDraft: this.props.canSavePublishDraft };


    return isMobile ?
    _react2.default.createElement(_.HeaderMobile, _extends({},
    sharedProps, {
      routeData: routeData,
      isMobileFiltersOpen: this.props.isMobileFiltersOpen,
      isMobileMenuOpen: this.props.isMobileMenuOpen,
      openMobileFilters: this.props.openMobileFilters,
      hideMobileFilters: this.props.hideMobileFilters,
      openMobileHeader: this.props.openMobileHeader,
      hideMobileHeader: this.props.hideMobileHeader,
      isDetailsModalOpen: this.props.isDetailsModalOpen,
      isPreview: this.props.isPreview,
      hideDetailsPopup: this.props.hideDetailsPopup,
      setFavoritesListState: this.props.setFavoritesListState,
      isModalContactsOpen: isModalContactsOpen,
      switchAuthModalType: this.props.switchAuthModalType,
      isFullLogo: this.isFullMobileLogo(),
      isNative: this.props.isNative })) :


    _react2.default.createElement(_.HeaderDesktop, _extends({},
    sharedProps, {
      switchAuthModalType: this.props.switchAuthModalType,
      userAuthentication: this.props.userAuthentication,
      setPaginationStepForAgentManage: setPaginationStepForAgentManage,
      profileImage: userData ? userData.profile_img : null,
      favoritesCount: this.props.favoritesCount,
      savedSearchesCount: this.props.savedSearchesCount,
      numberLeads: this.props.numberLeads,
      setFavoritesListState: this.props.setFavoritesListState,
      favoritesListIsActive: this.props.favoritesListIsActive }));


  };return AppHeader;}(_react.Component);exports.default = AppHeader;


AppHeader.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  translate: _propTypes2.default.func,
  switchAuthModalType: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  userAuthentication: _propTypes2.default.object,
  location: _propTypes2.default.string,
  route: _propTypes2.default.string,
  openAuthenticationModal: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  logOut: _propTypes2.default.func,
  publishClicked: _propTypes2.default.func,
  switchAccountView: _propTypes2.default.func,
  isMobileFiltersOpen: _propTypes2.default.bool,
  isMobileMenuOpen: _propTypes2.default.bool,
  openMobileFilters: _propTypes2.default.func,
  hideMobileFilters: _propTypes2.default.func,
  openMobileHeader: _propTypes2.default.func,
  hideMobileHeader: _propTypes2.default.func,
  isDetailsModalOpen: _propTypes2.default.bool,
  isPreview: _propTypes2.default.bool,
  hideDetailsPopup: _propTypes2.default.func,
  setFavoritesListState: _propTypes2.default.func,
  isNative: _propTypes2.default.bool,
  pushRoute: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  userHasProperties: _propTypes2.default.bool,
  userHasCompany: _propTypes2.default.bool,
  routeData: _propTypes2.default.object,
  propertyDetails: _propTypes2.default.object,
  setPaginationStepForAgentManage: _propTypes2.default.func,
  favoritesCount: _propTypes2.default.number,
  savedSearchesCount: _propTypes2.default.number,
  numberLeads: _propTypes2.default.number,
  favoritesListIsActive: _propTypes2.default.bool,
  canSavePublishDraft: _propTypes2.default.bool,
  savePublishDraft: _propTypes2.default.func,
  publishDraftSaved: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AppHeader/AppHeader.js
// module id = 2601
// module chunks = 0